import axios from '@/utils/axios'
import {business, doctorPrefix} from '@/api/common'

/**
 * 获取该患者随访记录
 *
 * @param {*} pageInfo
 * @param {*} queryParam
 * @returns
 */
export const followRecordList = (pageInfo, queryParam) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/followRecordList`,
    method: 'post',
    data: pageInfo,
    params: queryParam
  })
}
/**
 * 获取该患者随访记录
 *
 * @param {*} pageInfo
 * @param {*} queryParam
 * @returns
 */
export const threeMonthsNoFollow = (pageInfo, queryParam) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/threeMonthsNoFollow`,
    method: 'post',
    data: pageInfo,
    params: queryParam
  })
}
/**
 * 获取该医生随访记录
 *
 * @param {*} queryParam
 * @returns
 */
export const allRemainingTasks = (queryParam) => {
  return axios({
    url: `${business}${doctorPrefix}/follow/manager/allRemainingTasks`,
    method: 'post',
    data: queryParam
  })
}
/**
 * 根据随访记录里的患者编码获取该患者信息
 */
export const patientInfoFromFollow = (patientCode) => {
  return axios({
    url: `${business}${doctorPrefix}/follow/manager/patientInfoFromFollow`,
    method: 'get',
    params: {patientCode}
  })
}
/**
 * 获取当前医生随访列表计数
 */
export const getFollowStat = (queryParam) => {
  return axios({
    url: `${business}${doctorPrefix}/follow/manager/getFollowStat`,
    method: 'post',
    data: queryParam
  })
}
/**
 * 获取患者列表
 */
export const getPatientList = (queryParam) => {
  return axios({
    url: `${business}${doctorPrefix}/follow/manager/getPatientList`,
    method: 'post',
    data: queryParam
  })
}
/**
 * 创建随访任务
 */
export const creatFollowTasks = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/follow/manager/creatFollowTasks`,
    method: 'post',
    data: params
  })
}
/**
 * 编辑回答随访
 */
export const updateFollowTask = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/follow/manager/updateFollowTask`,
    method: 'post',
    data: params
  })
}

/**
 * 获取随访模板列表
 */
export const getFollowTplList = () => {
  return axios({
    url: `${business}${doctorPrefix}/follow/manager/getFollowTplList`,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/business/doctor/follow/index.js